var GuiMode = require("./../shared/guiMode.js");
var cio_datamodel = require("cio-datamodel");

module.exports = function(editorOptions, endpoints, editorMode) {
    var dataManagerConfig, authConfig, recorderConfig;

    if (editorOptions["environment"] == "offline") {
        // SERVICE CONTENT API
        dataManagerConfig = {
            content_server_client: {
                type:         "Offline"
            },
            asset_loader: {
                type:         "Dummy",
                datamodel_version: cio_datamodel.datamodel_version
            },
            document_loader: {
                type:         "Empty",
                datamodel: cio_datamodel
            },
            document_options: {
                mode:         editorOptions.mode,
                dataClass:    cio_datamodel.PackageData
            }
        };

        // AUTHENTICATION
        authConfig = {auth_required : false};
    } else {

        // SERVICE CONTENT API
        dataManagerConfig = {
            content_server_client: {
                type:         "ContentServer",
                serverurl:    endpoints["contentServer"]["server"],
                tenant:       endpoints["contentServer"]["tenant"],
                assetTypeRouter: {
                    "symbol": "/symbols",
                    "footprint": "/footprints",
                    "package": "/packages",
                    "component": "/components",
                    "circuit": "/circuits",
                    "library": "/libraries",
                    "3dmodel": "/3dmodels"
                }
            },
            asset_loader: {
                type:         "ContentServer",
                datamodel_version: cio_datamodel.datamodel_version
            },
            document_loader: {
                type:      "Static",
                datamodel: cio_datamodel,
                url:       endpoints["collabServer"]
            },
            document_options:      {
                readOnly:     editorOptions.mode <= GuiMode.INSPECT,
                creationAllowed: editorOptions.mode >= GuiMode.LIMITED_EDIT,
                id:           editorOptions["assetid"],
                version:      editorOptions["assetversion"],
                hub:          editorOptions["hub"],
                assetType:    "package",
                dataClass:    cio_datamodel.PackageData,
                disableIpcForking: editorOptions["disableIpcForking"],
                data:         editorOptions["data"],
                createNew:         editorOptions["createNew"]
            }
        };

        // AUTHENTICATION
        authConfig = {
            auth_required: true,
            env: editorOptions["environment"],
            urls: endpoints
        };
    }

    // EVENT RECORDER
    if(editorMode > GuiMode.VIEW){
        recorderConfig = {
            recording: editorOptions["recording"],
            eventsAPIServer: endpoints["eventsAPI"]["server"],
            eventsAPIAFC: endpoints["eventsAPI"]["AFC"]
        };
    }

    return {
        dataManagerConfig: dataManagerConfig,
        authConfig: authConfig,
        recorderConfig: recorderConfig
    }
};
